<div class="inputFieldset">
  <fieldset class="conditionInputs">
    <legend>Heating Conditions</legend>
    <div class="configurationDetailRow">
      @if (heatingEnteringDryBulbSelection) {
        <span>
          <label class="configurationInputLabel">Entering Dry Bulb:</label>
          <input type="number" class="configurationRatingTextInput" #heatingEnteringDryBulbInput
            [value]="heatingEnteringDryBulbSelection.Value"
            (change)="selectionChanged(heatingEnteringDryBulbSelection, heatingEnteringDryBulbInput.value || '0')">
          <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (heatingEnteringFluidTemperatureSelection) {
        <span>
          <label class="configurationInputLabel">Entering Fluid Temp:</label>
          <input type="number" class="configurationRatingTextInput" #heatingEnteringFluidTemperatureInput
            [value]="heatingEnteringFluidTemperatureSelection.Value"
            (change)="selectionChanged(heatingEnteringFluidTemperatureSelection, heatingEnteringFluidTemperatureInput.value || '0')">
          <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (heatingFluidTypeSelection) {
        <span>
          <label class="configurationInputLabel">Fluid Type:</label>
          <select class="configurationRatingTextInput" #heatingFluidTypeInput
            (change)="selectionChanged(heatingFluidTypeSelection, heatingFluidTypeInput.value)"
            [value]="heatingFluidTypeSelection.Value">
            @for (allowable of heatingFluidTypeSelection.Allowables; track allowable) {
              <option
                class="configurationSelectionOption" [value]="allowable.Value"
                            [selected]="heatingFluidTypeSelection.Value
                             && heatingFluidTypeSelection.Value.toString() === allowable.Value">
                {{ allowable.Description }}
              </option>
            }
          </select>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (heatingGlycolPercentageSelection) {
        <span>
          <label class="configurationInputLabel">Glycol %:</label>
          <input type="number" class="configurationRatingTextInput" #heatingGlycolPercentageInput
            [value]="heatingGlycolPercentageSelection.Value"
            (change)="selectionChanged(heatingGlycolPercentageSelection, heatingGlycolPercentageInput.value || '0')">
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      <span>
        <span class="configurationInputLabel">
          <select #heatingDeltaTypeInput
            (change)="deltaSelectionChanged(false, heatingDeltaTypeInput.value)"
            [value]="selectedHeatingDelta">
            @for (allowable of deltaSelections; track allowable) {
              <option [selected]="allowable === selectedHeatingDelta" [value]="allowable">{{ allowable }}</option>
            }
          </select>
        </span>
        <input type="number" class="configurationRatingTextInput" #heatingDeltaValueInput
          [value]="heatingDeltaValue"
          (change)="deltaValueChanged(false, heatingDeltaValueInput.value || '0')">
        <label class="configurationRatingUnitLabel">{{ getHeatingDeltaUnits() }}</label>
      </span>
      <span>
      </span>
    </div>
  </fieldset>
</div>
